/* eslint-disable no-console */
export const PAYPAL_EVENTS = {
  PAYPAL_SUBMISSION: 'paypal express',
  PAYPAL_PAY_LATER: 'paypal pay later'
};

let EVENT_LOGGING_ON = true;

const cartCheckoutAdobe = (eventName) => {
  try {
    if (EVENT_LOGGING_ON) {
      // need to create paypal component file in thd-analytics
      LIFE_CYCLE_EVENT_BUS.trigger('cartItem.DD_EVENT',
        {
          primaryCategory: 'button submission',
          eventName
        });
    }
  } catch (err) {
    console.error(err);
  }
};

export const logAnalytics = ({
  eventName,
  eventData
}) => {
  if (eventName === PAYPAL_EVENTS.PAYPAL_SUBMISSION || eventName === PAYPAL_EVENTS.PAYPAL_PAY_LATER) {
    cartCheckoutAdobe(eventName);
  } else {
    console.error('Event not handled', eventName, eventData);
  }

};
